import type { Conversation, Member } from "@/features/chat/types";

/** The member on the other side of a 1:1 (or the first non-me member). */
export function otherMember(conversation: Conversation, meId: string | null): Member | null {
  return conversation.members.find((m) => m.id !== meId) ?? conversation.members[0] ?? null;
}

/** Title shown for a conversation: the group name, or the other person's name. */
export function conversationTitle(conversation: Conversation, meId: string | null): string {
  if (conversation.kind === "group") return conversation.name || "Group";
  return otherMember(conversation, meId)?.name ?? "Direct message";
}

export function initials(name: string): string {
  return (
    name
      .split(" ")
      .map((part) => part[0])
      .slice(0, 2)
      .join("")
      .toUpperCase() || "?"
  );
}

/** Short, human time label for a message/preview timestamp. */
export function formatTime(iso: string | null): string {
  if (!iso) return "";
  const date = new Date(iso);
  const now = new Date();
  const sameDay = date.toDateString() === now.toDateString();
  return sameDay
    ? date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
    : date.toLocaleDateString([], { month: "short", day: "numeric" });
}
